<template>
  <svg
    width="22"
    height="23"
    viewBox="0 0 22 23"
    :fill="fill || 'black'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_52_19442)">
      <path
        d="M5.79732 0.624502C5.51802 0.804971 0.400439 5.95692 0.366064 6.08583C0.353174 6.14599 0.348877 9.53622 0.353174 13.6268L0.366064 21.0604L0.503564 21.3526C0.666846 21.6964 1.02778 22.096 1.32427 22.255C1.79692 22.5128 1.4231 22.4999 8.7106 22.4999C13.4543 22.4999 15.4438 22.487 15.6071 22.4526C16.1399 22.3409 16.6383 21.9714 16.8876 21.5073C17.1325 21.0433 17.1454 20.9487 17.1454 19.3202C17.1454 17.9925 17.1368 17.8206 17.068 17.6874C16.8532 17.2577 16.2215 17.2233 15.9551 17.6315C15.8864 17.7347 15.8778 17.8979 15.8563 19.26C15.8348 20.7038 15.8305 20.7811 15.7446 20.8929C15.6973 20.9573 15.6028 21.0518 15.5383 21.0991C15.4223 21.1893 15.4094 21.1893 8.77505 21.2022C2.36411 21.2108 2.12349 21.2108 1.97739 21.1335C1.89575 21.0862 1.78403 20.9874 1.73247 20.91L1.63364 20.7683V13.8804V6.99677L3.42974 6.97958C5.15278 6.96239 5.23013 6.9581 5.47935 6.86786C6.02505 6.66591 6.45044 6.24911 6.66958 5.70771C6.76841 5.46708 6.76841 5.42841 6.7813 3.62372L6.79419 1.78896L11.1083 1.79755C15.3879 1.81044 15.4223 1.81044 15.5383 1.90067C15.6028 1.94794 15.6973 2.04247 15.7446 2.10692C15.8305 2.21864 15.8348 2.29169 15.8563 4.0663C15.8778 5.8538 15.8821 5.90966 15.968 6.02997C16.2473 6.3995 16.7543 6.3995 17.0336 6.02997C17.1196 5.90966 17.1239 5.8581 17.1368 4.09638C17.154 2.15419 17.1411 2.0038 16.9391 1.58271C16.7071 1.08856 16.1571 0.663174 15.6071 0.547158C15.4481 0.512783 13.9571 0.499893 10.6829 0.499893H5.99067L5.79732 0.624502ZM5.42778 5.3081C5.38482 5.39403 5.28599 5.50575 5.20435 5.55731C5.06255 5.65614 5.03677 5.65614 3.80786 5.65614H2.55747L4.01841 4.19521L5.47935 2.73427L5.49224 3.94169C5.50083 5.0245 5.49224 5.1706 5.42778 5.3081Z"
        fill-opacity="0.8"
      />
      <path
        d="M11.0656 7.67578C10.9238 7.73164 10.739 7.95938 10.7047 8.10977C10.6359 8.42344 10.7777 8.71133 11.057 8.84023C11.2289 8.91758 11.3965 8.92188 14.8941 8.92188H18.5508L18.7355 8.82305C19.1781 8.59102 19.1953 7.98086 18.7699 7.71875C18.6324 7.63711 18.5465 7.63281 14.8898 7.63711C12.8359 7.63711 11.1129 7.6543 11.0656 7.67578Z"
        fill-opacity="0.8"
      />
      <path
        d="M8.60933 11.1974C8.26988 11.2791 8.04644 11.6013 8.1023 11.9322C8.14097 12.1556 8.35152 12.3791 8.58355 12.4392C8.71246 12.4736 9.63628 12.4865 11.7418 12.4779C14.6293 12.465 14.7238 12.4607 14.8656 12.3791C15.1019 12.2416 15.1921 12.0826 15.1921 11.8205C15.1921 11.5584 15.1019 11.3994 14.8656 11.2619C14.7238 11.1802 14.6335 11.1759 11.7332 11.1673C10.0918 11.163 8.68238 11.1759 8.60933 11.1974Z"
        fill-opacity="0.8"
      />
      <path
        d="M12.3479 14.804C12.0901 14.92 11.9698 15.1348 11.9956 15.4356C12.0085 15.6032 12.0429 15.6977 12.1202 15.7793C12.3479 16.0243 12.0901 16.0114 16.8425 16.0114C21.698 16.0114 21.3585 16.0329 21.5605 15.7364C21.6249 15.6375 21.655 15.5344 21.655 15.384C21.655 15.109 21.5347 14.9157 21.2983 14.8082C21.1222 14.7266 20.9675 14.7223 16.821 14.7223C12.7218 14.7223 12.5155 14.7266 12.3479 14.804Z"
        fill-opacity="0.8"
      />
    </g>
    <defs>
      <clipPath id="clip0_52_19442">
        <rect width="22" height="22" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {
  name: 'SentenceTemplateIcon',
  props: {
    fill: String
  }
};
</script>
